import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/footer/footer";
import ThankYouHeader from "../components/header/thankyou-header";

const ThankYouLayout = () => {

    return (
        <>
            <ThankYouHeader />
            <div className="main-section">
                <Outlet />
            </div>
            <Footer />
        </>
    );
};

export default ThankYouLayout;
